import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const CorporateServices = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Company Formation & Business Setup Services" 
      subtitle="Comprehensive company formation and business establishment services across UAE's leading Free Zones, offering streamlined processes and expert guidance to launch your business with complete regulatory compliance."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Expert Company Formation Services</h2>
            <p>
              We provide comprehensive company formation and business setup services across the UAE's premier Free Zones, offering expert guidance, streamlined processes, and complete regulatory compliance to establish your business efficiently in the UAE's thriving economic landscape.
            </p>
          </div>

          <div className="video-showcase-section" style={{marginBottom: '40px'}}>
            <h3 style={{fontSize: '1.8rem', fontWeight: '700', marginBottom: '24px', color: '#1a1a1a', textAlign: 'center'}}>
              Company Formation Process Overview
            </h3>
            
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={24}
              slidesPerView={3}
              navigation={{
                nextEl: '.video-swiper-button-next',
                prevEl: '.video-swiper-button-prev',
              }}
              pagination={{
                el: '.video-swiper-pagination',
                clickable: true,
                dynamicBullets: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }}
              className="video-swiper"
              style={{marginBottom: '32px'}}
            >
              <SwiperSlide>
                <div className="video-card">
                  <h4>UAE Business Setup Guide</h4>
                  <video 
                    controls 
                    poster="/images/Screenshot_72.png"
                  >
                    <source src="/videos/video1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <p>
                    Learn about our streamlined company formation process and Free Zone advantages
                  </p>
                </div>
              </SwiperSlide>
              
              <SwiperSlide>
                <div className="video-card">
                  <h4>Business Licensing Solutions</h4>
                  <video 
                    controls 
                    poster="/images/Screenshot_73.png"
                  >
                    <source src="/videos/video2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <p>
                    Discover our comprehensive licensing services and visa processing support
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="video-card">
                  <h4>Corporate Services Overview</h4>
                  <video controls>
                    <source src="/videos/video3.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <p>
                    Explore our comprehensive corporate services and business support solutions
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="video-swiper-navigation">
              <div className="video-swiper-button-prev"></div>
              <div className="video-swiper-pagination"></div>
              <div className="video-swiper-button-next"></div>
            </div>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Comprehensive Free Zone Company Formation</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We specialize in establishing businesses across UAE's premier Free Zones, providing end-to-end company formation services from initial consultation through complete business setup with all required licenses and permits.
                  </p>
                  
                  <div className="info-section">
                    <h4>Free Zone Expertise</h4>
                    <ul>
                      <li>UAE Free Zone company incorporation across multiple emirates</li>
                      <li>Specialized support for creative, media, and technology industries</li>
                      <li>Manufacturing, trading, and commercial business establishment</li>
                      <li>Financial services and fintech company setup</li>
                      <li>E-commerce and digital business formation</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Complete Setup Services</h4>
                    <ul>
                      <li>Business license procurement and activity selection (up to 15 activities)</li>
                      <li>Company name reservation and registration</li>
                      <li>Memorandum & Articles of Association drafting</li>
                      <li>Share certificate issuance and corporate documentation</li>
                      <li>Office space solutions (flexi-desk to private offices)</li>
                      <li>Corporate bank account opening facilitation</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/company-formation/company1_cleanup.jpg" 
                    alt="Free Zone Company Formation" 
                    onClick={() => openLightbox('/images/company-formation/company1_cleanup.jpg', 'Free Zone Company Formation')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Visa Processing & Immigration Support</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Complete visa processing and immigration support services for business owners, employees, and their families, ensuring seamless relocation and residency establishment in the UAE with full compliance and efficiency.
                  </p>
                  
                  <div className="info-section">
                    <h4>Visa Services Portfolio</h4>
                    <ul>
                      <li>Investor visa processing</li>
                      <li>Employee residence visa sponsorship and renewal</li>
                      <li>Family visa processing and dependent sponsorship</li>
                      <li>Emirates ID registration and medical examination coordination</li>
                      <li>Entry permit processing and status change assistance</li>
                      <li>E-channel registration for expedited immigration</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>PRO & Government Relations</h4>
                    <ul>
                      <li>Public Relations Officer (PRO) services</li>
                      <li>Government liaison and documentation support</li>
                      <li>Labor contract registration and renewal</li>
                      <li>Work permit processing and compliance</li>
                      <li>Document attestation and translation services</li>
                      <li>MOHRE and immigration authority coordination</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/company-formation/company2_cleanup.jpg" 
                    alt="Visa Processing Support" 
                    onClick={() => openLightbox('/images/company-formation/company2_cleanup.jpg', 'Visa Processing Support')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Business Licensing & Regulatory Compliance</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Comprehensive business licensing services and ongoing regulatory compliance support, ensuring your company maintains all required permits, renewals, and adheres to UAE Free Zone regulations and mainland requirements.
                  </p>
                  
                  <div className="info-section">
                    <h4>License Types & Activities</h4>
                    <ul>
                      <li>Commercial trading licenses (import/export, general trading)</li>
                      <li>Professional service licenses (consultancy, media, education)</li>
                      <li>Industrial manufacturing licenses with production permits</li>
                      <li>E-commerce and digital business licenses</li>
                      <li>Freelancer permits and individual professional licenses</li>
                      <li>Mixed activity licenses combining commercial and professional services</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Ongoing Compliance Support</h4>
                    <ul>
                      <li>Annual license renewal and fee management</li>
                      <li>Business activity modification and expansion</li>
                      <li>Economic Substance Regulation (ESR) filing</li>
                      <li>Corporate governance and shareholding compliance</li>
                      <li>Regulatory updates and notification management</li>
                      <li>Authority liaison and inspection preparation</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/company-formation/company3_cleanup.jpg" 
                    alt="Business Licensing" 
                    onClick={() => openLightbox('/images/company-formation/company3_cleanup.jpg', 'Business Licensing')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Company Formation Services?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We deliver streamlined company formation services with comprehensive support, established partnerships across UAE Free Zones, and proven expertise in business establishment with complete regulatory compliance and ongoing operational support.
                </p>
                
                <div className="info-section">
                  <h4>24-Hour Business Setup</h4>
                  <p>Rapid company formation with some packages operational within 24 hours, ensuring quick market entry.</p>
                </div>
                
                <div className="info-section">
                  <h4>100% Foreign Ownership</h4>
                  <p>Complete business ownership for international entrepreneurs with no local partner requirements in Free Zones.</p>
                </div>
                
                <div className="info-section">
                  <h4>Comprehensive Package Solutions</h4>
                  <p>All-inclusive packages covering licensing, visa processing, office space, and banking facilitation.</p>
                </div>
                
                <div className="info-section">
                  <h4>Multi-Activity Flexibility</h4>
                  <p>Support for up to 15 business activities under one license with flexible commercial and professional combinations.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    Launch your business in the UAE with confidence through our established partnerships with leading Free Zone authorities, comprehensive regulatory expertise, and proven track record of successful company formations across diverse industries and business models.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Company Formation Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0', 'Company Formation Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Launch Your UAE Business Today</h3>
            <p>Ready to establish your company in the UAE? Contact our business formation specialists for expert guidance and seamless setup.</p>
            <a href="/contact" className="btn immigration-btn-primary">Start Company Formation</a>
          </div>
        </div>
      </section>
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default CorporateServices;